export const generateRemoteUrl = (searchQuery: string, showDeprecated: boolean, types: string[]): string => {
  const filters = [];

  if (showDeprecated) {
    filters.push("get_deprecated=true");
  }

  if (searchQuery) {
    filters.push(`search=${searchQuery.toLowerCase()}`);
  }

  if (types?.length > 0) {
    filters.push(`types=${types.join(",")}`);
  }

  return `evaluations${filters.length > 0 ? `?${filters.join("&")}` : ""}`;
};
